<template>
  <div :class="componentClassName">
    <a-page-heading>トライアル情報管理</a-page-heading>
    <m-section>
      <m-action-card title="トライアル情報編集" :header-border="true" :narrow-body="true">
        <form ref="form" class="t-setting-trial-edit__form">
          <div v-if="companyInfoData" class="t-settings-trial-add__fields">
            <m-form-input label="対象サービス">
              <a-text-field
                id="targetService"
                v-model="companyInfoData.voicedxOnlyFlagView"
                type="text"
                :disabled="true"
              />
            </m-form-input>
            <m-form-input label="契約ID">
              <a-text-field id="companyID" v-model="companyInfoData.companyID" type="text" :disabled="true" />
            </m-form-input>
            <m-form-input label="企業名">
              <a-text-field
                id="companyName"
                v-model="companyInfoData.companyName"
                type="text"
                placeholder="入力してください"
                maxlength="40"
                required
                :disabled="isClosed || readOnly"
              />
            </m-form-input>
            <m-form-input label="氏名">
              <a-text-field
                id="masterAdminLastName"
                v-model="companyInfoData.adminLastName"
                type="text"
                placeholder="入力してください"
                maxlength="20"
                required
                :disabled="isClosed || readOnly"
              />
              <a-text-field
                id="masterAdminFirstName"
                v-model="companyInfoData.adminName"
                type="text"
                placeholder="入力してください"
                maxlength="20"
                required
                :disabled="isClosed || readOnly"
              />
            </m-form-input>
            <m-form-input label="氏名カナ">
              <a-text-field
                id="masterAdminLastNameKana"
                v-model="companyInfoData.adminLastKanaName"
                type="text"
                placeholder="全角カタカナ"
                pattern="[ァ-ヶー]+"
                maxlength="20"
                required
                :disabled="isClosed || readOnly"
              />
              <a-text-field
                id="masterAdminFirstNameKana"
                v-model="companyInfoData.adminKanaName"
                type="text"
                placeholder="全角カタカナ"
                pattern="[ァ-ヶー]+"
                maxlength="20"
                required
                :disabled="isClosed || readOnly"
              />
            </m-form-input>
            <m-form-input label="メールアドレス">
              <a-text-field
                id="masterAdminMailAddress"
                v-model="companyInfoData.adminEmail"
                type="email"
                placeholder="キャリアメールは使えません"
                maxlength="50"
                required
                disabled="true"
              />
            </m-form-input>
            <m-form-input label="電話番号">
              <a-text-field
                id="masterAdminTelNumber"
                v-model="companyInfoData.adminPhoneNumber"
                type="tel"
                placeholder="ハイフンなし"
                maxlength="11"
                pattern="[0-9]{10,11}"
                required
                :disabled="isClosed || readOnly"
              />
            </m-form-input>

            <br />
            <m-form-input label="トライアル開始日">
              <a-text-field id="othersOpeningDate" :value="companyInfoData.startDate" type="text" disabled="true" />
            </m-form-input>

            <m-form-input label="廃止日">
              <a-text-field
                id="othersCancellationDate"
                v-model="companyInfoData.closeDate"
                type="text"
                disabled="true"
              />
            </m-form-input>

            <m-form-input label="ステータス">
              <a-text-field
                id="othersCancellationDate"
                v-model="companyInfoData.contractStatusName"
                type="text"
                disabled="true"
              />
            </m-form-input>
          </div>
          <m-form-action-buttons>
            <template v-if="!readOnly">
              <a-button
                id="delete"
                variant="outlined"
                color="primary"
                :disabled="!flagAllButtonEnable"
                @click="handleDialogCompanyRemove"
                >削除</a-button
              >
              <a-button
                v-if="companyInfoData"
                id="store"
                variant="block"
                color="primary"
                :disabled="isClosed || !flagAllButtonEnable"
                @click="handleDialogCompanyUpdate"
                >保存</a-button
              >
            </template>
            <a-button
              id="cancel"
              variant="outlined"
              color="primary"
              :disabled="!flagAllButtonEnable"
              @click="handleCancelClick"
              >キャンセル</a-button
            >
          </m-form-action-buttons>
        </form>
      </m-action-card>
    </m-section>
  </div>
  <teleport to="body">
    <o-modal
      id="settingTrialEdit_resultModal"
      v-model:visible="resultModalVisible"
      class="o-modal-remove-phone-number-confirmation"
      footer-variant="confirmation"
      width="442px"
      :footer-shadow="false"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
    >
      <template #title>{{ resultModalTitle }}</template>
      <a-text>
        <!-- eslint-disable -->
        <span v-html="resultModalContent" />
        <!-- eslint-enable -->
      </a-text>
      <template #footer>
        <a-button
          id="buttonResultOk"
          variant="block"
          color="primary"
          label="OK"
          size="small"
          @click="handleCloseModal(next)"
        />
      </template>
    </o-modal>
  </teleport>
  <teleport to="body">
    <o-modal
      id="settingTrialEdit_deleteResultModal"
      v-model:visible="deleteResultModalVisible"
      class="o-modal-remove-phone-number-confirmation"
      footer-variant="confirmation"
      width="442px"
      :footer-shadow="false"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
    >
      <template #title>{{ resultModalTitle }}</template>
      <a-text>
        <!-- eslint-disable -->
        <span v-html="resultModalContent" />
        <!-- eslint-enable -->
      </a-text>
      <template #footer>
        <a-button
          id="buttonDeleteResultOk"
          variant="block"
          color="primary"
          label="OK"
          size="small"
          @click="handleDeleteCloseModal"
        />
      </template>
    </o-modal>
  </teleport>
  <teleport to="body">
    <o-modal
      v-if="removeCompanyDialogVisible"
      id="settingTrialEdit_removeModal"
      v-model:visible="removeCompanyDialogVisible"
      class="o-modal-remove-user-confirmation"
      footer-variant="confirmation"
      width="442px"
      :footer-shadow="false"
      @close="handleCancelRemoveCompany"
    >
      <template #title> トライアル情報削除確認 </template>
      <a-text :center="true">
        <!-- eslint-disable -->
        <span v-html="removeCompanyConfirmationMessageText" />
        <!-- eslint-enable -->
      </a-text>
      <template #footer>
        <a-button
          id="infoDeleteYes"
          variant="block"
          color="primary"
          label="はい"
          size="small"
          @click="handleConfirmRemoveCompany"
        />
        <a-button
          id="infoDeleteNo"
          variant="outlined"
          color="primary"
          label="いいえ"
          size="small"
          @click="handleCancelRemoveCompany"
        />
      </template>
    </o-modal>
  </teleport>
</template>

<script>
import { mapModifiers } from '@/libs/component';
import APageHeading from '@/components/atoms/page-heading';
import MSection from '@/components/molecules/section';
import MActionCard from '@/components/molecules/action-card';
import AButton from '@/components/atoms/button';
import MFormActionButtons from '@/components/molecules/form-action-buttons';
import MFormInput from '@/components/molecules/form-input';
import ATextField from '@/components/atoms/text-field';
// import ACaptionList from '@/components/atoms/caption-list';
import ASelectField from '@/components/atoms/select-field';
import { cloneDeep } from 'lodash';

import { customRequest } from '@/common/customRequest.js';
import { messageContent } from '@/common/messageContent.js';
import { customValidate } from '@/common/customValidate.js';
import { POINT } from '@/libs/constants';

export default {
  name: 't-setting-trial-edit',
  components: {
    APageHeading,
    MSection,
    MActionCard,
    AButton,
    MFormInput,
    ATextField,
  },
  mixins: [customRequest, customValidate],
  props: {
    class: {
      type: String,
      default: '',
    },
    companyID: {
      type: String,
      default: '',
    },
    authInfo: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      companyInfoData: {},
      companyInfo: {},
      resultModalTitle: '',
      resultModalContent: '',
      resultModalVisible: false,
      isClosed: false,
      historyList: [],
      formData: {
        documents: [{}],
      },
      contractStatusList: {
        use: 'トライアル利用中',
        transiting: '移行期間',
        close: '廃止済',
      },
      removeCompanyConfirmationMessage: `{{ companyID }} を削除しますか？<br />`,
      removeCompanyDialogVisible: false,
      deleteResultModalVisible: false,
      removeUploadDialogVisible: false,
      removeContactConfirmationMessageText: '',
      stay: false,
      flagAllButtonEnable: true, //#1892

      // #2456
      spCharCheckList: [
        {
          name: '企業名',
          fieldName: 'companyName',
        },
        {
          name: '氏名',
          fieldName: 'adminLastName',
        },
        {
          name: '氏名',
          fieldName: 'adminName',
        },
        {
          name: '氏名カナ',
          fieldName: 'adminLastKanaName',
        },
        {
          name: '氏名カナ',
          fieldName: 'adminKanaName',
        },
        {
          name: 'メールアドレス',
          fieldName: 'adminEmail',
        },
        {
          name: '電話番号',
          fieldName: 'adminPhoneNumber',
        },
      ],
      readOnly: false,
    };
  },
  computed: {
    componentClassName() {
      const baseClassName = mapModifiers('t-setting-trial-edit');
      return `${baseClassName} ${this.class}`.trim();
    },
    removeCompanyConfirmationMessageText() {
      if (this.$route.query.companyID) {
        return this.convertMessage(this.removeCompanyConfirmationMessage, this.$route.query.companyID);
      } else {
        return this.removeCompanyConfirmationMessage;
      }
    },
  },
  mounted() {
    if (this.companyID !== POINT) {
      this.$router.push({ path: '/permission-denied' });
    }

    this.flagAllButtonEnable = true; //#1892

    const companyID = this.$route.query.companyID;

    if (this.authInfo === 'operator' || (companyID === POINT && this.authInfo === 'soOperator')) {
      this.readOnly = true;
    }

    if (companyID) {
      this.postRequest('/companymgmt/search', { companyID: companyID })
        .then(e => {
          if (e.status === 'success') {
            e.data.voicedxOnlyFlagView = 'true';
            if (e.data.voicedxOnlyFlag !== true) {
              e.data.voicedxOnlyFlag = false;
              e.data.voicedxOnlyFlagView = 'false';
            }

            this.companyInfoData = e.data;
            const arrAdminName = this.companyInfoData.adminName.split('_');
            this.companyInfoData.adminLastName = arrAdminName[0];
            this.companyInfoData.adminName = arrAdminName[1];

            const arrAdminKanaName = this.companyInfoData.adminKanaName.split('_');
            this.companyInfoData.adminLastKanaName = arrAdminKanaName[0];
            this.companyInfoData.adminKanaName = arrAdminKanaName[1];

            this.companyInfoData.openDay = this.companyInfoData.openDay.replace(/-/g, '');

            if (this.companyInfoData.voicedxOnlyFlag) {
              this.companyInfoData.voicedxOnlyFlagView = 'トライアル COTOHA Voice DX Basic';
            } else {
              this.companyInfoData.voicedxOnlyFlagView = 'トライアル COTOHA Call Center';
            }

            if (this.companyInfoData.trialStatus) {
              if (this.companyInfoData.trialStatus in this.contractStatusList) {
                this.companyInfoData.contractStatusName = this.contractStatusList[this.companyInfoData.trialStatus];
              } else {
                this.companyInfoData.contractStatusName = '';
              }
              if (this.companyInfoData.trialStatus === 'close') {
                this.isClosed = true;
              }
            } else {
              this.companyInfoData.contractStatusName = '';
            }
          }
        })
        .catch(error => {
          console.log(error);
          this.showErrorModal(messageContent.requireTry('検索'));
        });
    }
  },
  methods: {
    handleCompanyEdit() {
      this.handleCancelCancelContractCompany();
      // #2456 特殊記号チェックを追加
      for (const item of this.spCharCheckList) {
        if (this.hasSpecialCharacterInObject({ keyWord: this.companyInfoData[item.fieldName].replace(/\r?\n/g, '') })) {
          this.showErrorModal(item.name + 'に' + messageContent.hasSpecialCharacter);
          return '';
        }
      }

      const sendData = {
        companyID: this.companyInfoData.companyID,
        companyName: this.companyInfoData.companyName ? this.companyInfoData.companyName : '',
        lastname: this.companyInfoData.adminLastName ? this.companyInfoData.adminLastName : '',
        name: this.companyInfoData.adminName ? this.companyInfoData.adminName : '',
        lastname_kana: this.companyInfoData.adminLastKanaName ? this.companyInfoData.adminLastKanaName : '',
        name_kana: this.companyInfoData.adminKanaName ? this.companyInfoData.adminKanaName : '',
        adminPhoneNumber: this.companyInfoData.adminPhoneNumber ? this.companyInfoData.adminPhoneNumber : '',
        adminEmail: this.companyInfoData.adminEmail ? this.companyInfoData.adminEmail : '',
        voicedxOnlyFlag: this.companyInfoData.voicedxOnlyFlag ? true : false,
        openDay: this.companyInfoData.openDay ? this.companyInfoData.openDay : '',
        responderName: this.companyInfoData.responderName ? this.companyInfoData.responderName : '',
      };

      this.flagAllButtonEnable = false; //#1892

      return this.postRequest('/companymgmt/updateTrial', { data: sendData })
        .then(e => {
          if (e.status === 'success') {
            this.showInfoModal(messageContent.trialInfoUpdated, '/triallist');
          } else {
            if (e.msg !== '') {
              this.showErrorModal(e.msg);
            } else {
              this.showErrorModal(messageContent.trialInfoUpdateFailed);
            }
          }
        })
        .catch(() => {
          this.showErrorModal(messageContent.trialInfoUpdateFailed);
        });
    },
    handleCancelClick() {
      this.$router.push('/triallist');
    },
    handleDialogCompanyRemove() {
      this.removeCompanyDialogVisible = true;
      this.flagAllButtonEnable = false; //#1892
    },
    handleDialogCompanyUpdate() {
      this.flagAllButtonEnable = false; //#1892
      this.handleCompanyEdit(cloneDeep(this.companyInfoData));
    },
    handleCompanyRemove() {
      const self = this;
      const formDataTmp = {
        companyID: this.$route.query.companyID,
      };
      this.postRequest('/companymgmt/deleteTrial', formDataTmp)
        .then(e => {
          if (e.status === 'success') {
            self.deleteResultModalVisible = true;
            this.resultModalTitle = messageContent.infoModalTitle;
            this.resultModalContent = `トライアル情報${this.$route.query.companyID}を削除しました。`;
            this.stay = false;
          } else if (e.status === 'companyInUse') {
            self.showErrorModal(messageContent.canNotDeleteUncanceledContract);
          } else if (e.status === 'callerNumberExist') {
            self.showErrorModal(messageContent.notReleaseVDXAndCCCUnlessDeleteNumber());
          } else {
            self.showErrorModal(messageContent.requireTry('トライアル情報削除'));
          }
          this.flagAllButtonEnable = true; //#1892
        })
        .catch(() => {
          self.showErrorModal(messageContent.requireTry('トライアル情報削除'));
          this.flagAllButtonEnable = true; //#1892
        });
    },
    handleConfirmRemoveCompany() {
      this.removeCompanyDialogVisible = false;
      this.flagAllButtonEnable = false; //#1892
      this.handleCompanyRemove();
    },
    handleCancelRemoveCompany() {
      this.removeCompanyDialogVisible = false;
      this.flagAllButtonEnable = true; //#1892
    },
    handleCloseModal(next) {
      if (next) {
        this.$router.push(next);
      }
      this.resultModalVisible = false;
      this.resultModalTitle = '';
      this.resultModalContent = '';
      this.flagAllButtonEnable = true; //#1892
    },
    handleDeleteCloseModal() {
      this.deleteResultModalVisible = false;
      this.resultModalTitle = '';
      this.resultModalContent = '';
      if (!this.stay) {
        this.$router.push('/triallist');
      }
    },
    handleCancelCancelContractCompany() {
      this.cancelContractCompanyDialogVisible = false;
      this.flagAllButtonEnable = true;
    },
    showErrorModal(message) {
      this.resultModalVisible = true;
      this.resultModalTitle = messageContent.errorModalTitle;
      this.resultModalContent = message;
    },
    showInfoModal(message, next = '') {
      this.resultModalVisible = true;
      this.resultModalTitle = messageContent.infoModalTitle;
      this.resultModalContent = message;
      this.next = next;
    },
    replaceSpecialCharacter: function (string) {
      if (typeof string !== 'string') return string;
      return string.replace(/&|'|"|<|>|\r?\n|\r/g, '');
    },
    convertMessage(message, newValue) {
      const newMessage = message;
      // #2772
      return newMessage.replace(/\{{(.+?)\}}/g, this.replaceSpecialCharacter(newValue));
    },
  },
};
</script>
